import { HiddenDataWrapper } from "helpers/hiddenData";
import { requiredField } from "helpers/validators";
import React from "react";

const Markup = ({
    renderField,
    renderCheckbox,
    Button,
    renderDocuments,
    renderSelect,
    renderFlags,
    children,
    renderManagement,
    values,
    ...props
}) => {
    const {
        name,
        isForeign,
        inn,
        kpp,
        ogrn,
        address,
        city,
        street,
        houseNumber,
        status,
        analyzeStrictOffsetHours,
        counterpartyGroupId,
        mailingAddress,
        comment,
        noteForDrivers,
        isInsolvent,
        insolvencyComment,
        bankId,
        bankName,
        correspondentAccount,
        settlementAccount,
    } = props;
    return (
        <>
            {renderField(name)}
            {renderCheckbox(isForeign)}
            <HiddenDataWrapper>{renderField(inn)}</HiddenDataWrapper>
            <HiddenDataWrapper>{renderField(kpp)}</HiddenDataWrapper>
            <HiddenDataWrapper>{renderField(bankId)}</HiddenDataWrapper>
            <HiddenDataWrapper>{renderField(bankName)}</HiddenDataWrapper>
            <HiddenDataWrapper>{renderField(correspondentAccount)}</HiddenDataWrapper>
            <HiddenDataWrapper>{renderField(settlementAccount)}</HiddenDataWrapper>
            {renderField(ogrn)}
            {renderField(address)}
            {renderField(city)}
            {renderField(street)}
            {renderField(houseNumber)}
            {renderManagement?.()}
            {renderSelect(counterpartyGroupId)}
            {renderField({
                ...analyzeStrictOffsetHours,
                inputProps: {
                    ...analyzeStrictOffsetHours?.inputProps,
                    onKeyDown: (e) => ["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault(),
                },
            })}
            {renderField(noteForDrivers)}
            {renderField(mailingAddress)}
            {renderField(comment)}
            {renderSelect(status)}
            {renderCheckbox(isInsolvent)}
            {values.isInsolvent && renderField({ ...insolvencyComment, required: true, validators: [requiredField] })}
            {renderDocuments()}
            {children}
            {!!Button && <Button />}
        </>
    );
};

export default Markup;
